export const PAIRING_CONTEXT = 'pairing';

export const MAINTENANCE_CONTEXT = 'help';

export const ADMIN_CONTEXT = 'admin';
export const ADMIN_PAIR_ROUTE = 'pair';
export const ADMIN_LOGIN_ROUTE = 'login';

export const SIGNAGE_CONTEXT = 'signage';
export const SIGNAGE_ERROR_ROUTE = 'error';
export const SIGNAGE_DISPLAY_LAYOUT_ROUTE = 'display';

export const SIGNAGE_PREVIEW_PREFIX = 'preview';

export const EXTERNAL_AUTH_ROUTE = 'external-auth';
export const EXTERNAL_AUTH_PROVIDER_ROUTE = 'provider';
